import { useEffect } from "react";

import { addBreadcrumb } from "@/sentry";

type PermissionsPolicyViolationBody = ReportBody & {
  message?: string;
  sourceFile?: string | null;
};

export const usePermissionsPolicyViolations = () => {
  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof ReportingObserver === "undefined"
    ) {
      return;
    }

    let observer: ReportingObserver | undefined;
    try {
      observer = new ReportingObserver(
        (reports) => {
          for (const report of reports) {
            if (report.type !== "permissions-policy-violation") continue;
            const body = (report.body ?? {}) as PermissionsPolicyViolationBody;
            addBreadcrumb({
              category: "permissions-policy",
              level: "warning",
              message: `${body.message} - ${body.sourceFile}`,
            });
          }
        },
        { types: ["permissions-policy-violation"], buffered: true },
      );
      observer.observe();
    } catch {
      observer = undefined;
    }

    return () => observer?.disconnect();
  }, []);
};
